export const toggleMobileNav = (payload) => {
  return { type: "TOGGLE_MOBILE_NAV", payload }
}